import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {  FaEnvelope, FaPhoneAlt, FaHome } from 'react-icons/fa';

const TermsAndConditions = () => {
  return (
    <Container fluid className="bg-light text-dark py-5" style={{ fontSize: '12px' }}>
      <Container>
        <Row>
          <Col>
            <h2 className="text-center text-info fw-bold mb-4">Terms and Conditions</h2>
            <ul className='text-start'>
            <p>
              Welcome to the official website of Bandaru Mahesh, Founder of Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy. These terms and conditions outline the rules and regulations for the use of our websites and services.
            </p>
            <h5>1. Introduction</h5>
            <p>
              By accessing our websites, you agree to comply with these terms and conditions. If you do not agree with any of these terms, you are prohibited from using or accessing our sites.
            </p>
            <h5>2. Intellectual Property Rights</h5>
            <p>
              2.1 Copyright and Trademarks: All content on this website, including logos and trademarks of Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy, is protected under copyright laws. Unauthorized use is strictly prohibited.
              <br />
              2.2 Usage Rights: Users are permitted to access and use the website materials for personal purposes only. Commercial use requires explicit permission.
            </p>
            <h5>3. User Obligations</h5>
            <p>
              3.1 Account Security: You are responsible for maintaining the confidentiality of your account credentials. Any unauthorized activity under your account may result in suspension.
              <br />
              3.2 Compliance with Laws: Users must comply with applicable laws, including the Indian Penal Code (IPC) and the Information Technology Act.
              <br />
              3.3 Prohibited Activities: Users are restricted from illegal activities, including hacking and defamation.
            </p>
            <h5>4. Content Ownership and User Contributions</h5>
            <p>
              4.1 User-Generated Content: All content submitted to our platforms, including Olewin Academy forums, becomes our property.
              <br />
              4.2 Content Monitoring: We reserve the right to monitor and remove any inappropriate content.
            </p>
            <h5>5. Privacy Policy</h5>
            <p>
              5.1 Data Collection: Personal information collected via Olewin websites will be used in accordance with our Privacy Policy.
              <br />
              5.2 Cookies: Our websites use cookies for enhanced user experience.
              <br />
              5.3 Data Security: While we employ robust security measures, we cannot guarantee absolute data security.
            </p>
            <h5>6. Use of IPC Sections</h5>
            <p>
              6.1 Defamation (IPC Section 499): Users must not post defamatory content regarding Olewin, its subsidiaries, or any third parties.
              <br />
              6.2 Hacking and Unauthorized Access (IPC Sections 66 & 67 of IT Act): Unauthorized access is prohibited and may result in prosecution.
              <br />
              6.3 Fraud (IPC Section 420): Fraudulent activities will be handled under applicable legal provisions.
            </p>
            <h5>7. Limitation of Liability</h5>
            <p>
              7.1 General Disclaimer: Content on Olewin websites is provided "as is." We do not guarantee accuracy or completeness.
              <br />
              7.2 Liability Exclusions: We are not liable for indirect or incidental damages arising from website use.
              <br />
              7.3 Links to External Sites: We are not responsible for the content on external websites linked from our pages.
            </p>
            <h5>8. Governing Law and Jurisdiction</h5>
            <p>
              All terms are governed by Indian laws, and any disputes fall under the jurisdiction of [Your State/City] courts.
            </p>
            <h5>9. Dispute Resolution</h5>
            <p>
              9.1 Negotiation: Parties shall resolve disputes amicably within 30 days of notification.
              <br />
              9.2 Arbitration: If unresolved, arbitration will follow under the Arbitration and Conciliation Act.
            </p>
            <h5>10. Termination</h5>
            <p>
              We may terminate or suspend access to our websites at our discretion for violations.
            </p>
            <h5>11. Indemnification</h5>
            <p>
              Users agree to indemnify Olewin, OlewinAI, OlewinTechsolutions, and related entities from any claims arising due to misuse of our websites.
            </p>
            <h5>12. Changes to Terms and Conditions</h5>
            <p>
              We may update these terms without prior notice. Check this page periodically.
            </p>
            <h5>13. Refund and Cancellation Policy</h5>
            <p>
              Refunds are not applicable for digital services unless otherwise stated.
              <br />
              Cancellation requests must be sent to [your.email@example.com].
            </p>
            <h5>14. Copyright Infringement</h5>
            <p>
              If you believe your copyright is violated, notify us at [your.email@example.com].
            </p>
            <h5>15. Advertisements</h5>
            <p>
              We do not endorse third-party advertisements displayed on our websites.
            </p>
            <h5>16. Force Majeure</h5>
            <p>
              We are not liable for events beyond our control, such as natural disasters.
            </p>
            <h5>17. Severability</h5>
            <p>
              Invalid provisions will not affect the enforceability of other terms.
            </p>
            <h5>18. Waiver</h5>
            <p>
              Failure to enforce any provision is not a waiver of our rights.
            </p>
            <h5>19. Assignment</h5>
            <p>
              You cannot assign your rights without our consent.
            </p>
            <h5>20. Entire Agreement</h5>
            <p>
              These terms constitute the full agreement between you and our websites.
            </p>
            <h5>21. Contact Information</h5>
            <p>
              For inquiries, reach us at:
              <br />
              <FaEnvelope className="me-1" /> Email: your.email@example.com
              <br />
              <FaPhoneAlt className="me-1" /> Phone: +123-456-7890
              <br />
              <FaHome className="me-1" /> Address: 1234 Main St, Your City, Country
            </p>
            <h5>22. Disclaimer of Warranties</h5>
            <p>
              We do not warrant the accuracy of information on our websites.
            </p>
            <h5>23. Updates and Modifications</h5>
            <p>
              These terms were last updated on [Last Updated Date]. Regularly review them for changes.
            </p>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default TermsAndConditions;
